module.exports = __webpack_public_path__ + "img/icon-addi.ba2de6fa.svg";